var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWordFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.86719C12.979 2.86719 11.6875 1.5835 11.6875 0H2.5C1.94772 0 1.5 0.447715 1.5 1V15C1.5 15.5523 1.94772 16 2.5 16H13.5625C14.1148 16 14.5625 15.5523 14.5625 15V2.86719Z",
    fill: "url(#paint0_linear_1120_126676)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.875C12.9747 2.875 11.6875 1.58782 11.6875 0Z",
    fill: "#AAC9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59542 5.09082H8.40487L9.42766 8.80963L10.1148 5.09082H11.1517L9.91867 10.6666H8.9696L8.02054 6.77107L7.02912 10.6666H6.08006L4.84863 5.09082H5.88554L6.57263 8.80963L7.59542 5.09082Z",
    fill: "#FCFCFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_126676",
    x1: 8.03125,
    y1: 0,
    x2: 8.03125,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A8AF9"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWordFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/word-file-icon.02d382cd9c1ac1516a842b0324c57b30.svg";